import {XHTTP} from '@/shared/xhttp';
import {OptionService} from '@/xhttp';

@XHTTP(OptionService, '/option')
export class Option {

	private _id: number;
	private _type: string;
	private _floatVal: number;
	private _stringVal: string;

	/////////////
	// Getters //
	/////////////

	public get id(): number {
		return this._id;
	}

	public get type(): string {
		return this._type;
	}

	public get floatVal(): number {
		return this._floatVal;
	}

	public get stringVal(): string {
		return this._stringVal;
	}

	/////////////
	// Setters //
	/////////////

	public set id(value: number) {
		this._id = value;
	}

	public set type(value: string) {
		this._type = value;
	}

	public set floatVal(value: number) {
		this._floatVal = value;
	}

	public set stringVal(value: string) {
		this._stringVal = value;
	}

	///////////////
	// Serialize //
	///////////////

	public toJSON(): any {
		return {
			id     : this._id,
			type: this._type,
			floatVal: this._floatVal,
			stringVal: this._stringVal,
		};
	}

	public fromJSON(data: any): this {
		this._id   = data.id;
		this._type   = data.type;
		this._floatVal   = data.floatVal;
		this._stringVal   = data.stringVal;
		return this;
	}

	////////////
	// Others //
	////////////

}